import React from 'react';
import { FormItemBase } from "./FormUI";
import { SanitizeClassNames } from '../common';
import './TimeStepper.css';
import Icon from './Icon';

export default class TimeStepper extends FormItemBase{

    _checkValue(val){
        if(!isNaN(this.props.max)){
            if(val > this.props.max)val = this.props.max;
        }

        if(!isNaN(this.props.min)){
            if(val < this.props.min)val = this.props.min;
        }

        return val;
    }

    increment = ()=>{
        this._onValueChanged(this._checkValue(this.value + this.incr));
    }

    decrement = ()=>{
        this._onValueChanged(this._checkValue(this.value - this.incr));
    }

    get value(){
        return Number(isNaN(this.state.value)? 0:this.state.value);
    }

    get incr(){
        return Number(isNaN(this.props.incr)? 1:this.props.incr);
    }


    render(){
        return(
            <div className={SanitizeClassNames(this, 'time-stepper table align-middle align-center')}>
                <div>
                    <div onClick={this.increment}><Icon icon='arrow' className='arrow up'  /></div>
                    <div>{this.value} (m)</div>
                    <div onClick={this.decrement}><Icon icon='arrow' className='arrow down'  /></div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/TimeStepper.js